import { ErrorBanner } from "../components/ui";
import { WidePanel } from "../components/Workspace";
import { FilterBar } from "./reports/FilterBar";
import { TicketTable } from "./reports/tables";
import { useTicketReport } from "./reports/useTicketReport";

const formatTime = (iso: string): string =>
  new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

// Every engineering ticket, newest first, with the same filters as the reports. Open to all staff, like the reports.
export function AllTickets() {
  const { query, all, filter, rows, options, setFilter } = useTicketReport();
  return (
    <WidePanel>
      <div className="phase-head">
        <h1>All tickets</h1>
        <p>
          Every engineering ticket raised through Slack and Triage Desk since August 2025, newest first. Filter them, read the details and download the list as a CSV.
          {query.data && <> Updated {formatTime(query.data.generatedAt)}.</>}
          {query.data && (
            <>
              {" "}
              <button type="button" className="link-button" disabled={query.isFetching} onClick={() => void query.refetch()}>
                {query.isFetching ? "Refreshing…" : "Refresh"}
              </button>
            </>
          )}
        </p>
      </div>
      {query.isPending && <p className="record-note">Loading…</p>}
      {query.isError && <ErrorBanner>We couldn't load the tickets. Refresh the page to try again.</ErrorBanner>}
      {query.data && (
        <>
          <FilterBar filter={filter} options={options} onChange={setFilter} />
          <p className="record-note">
            Showing {rows.length.toLocaleString("en-GB")} of {all.length.toLocaleString("en-GB")} tickets.
          </p>
          <TicketTable rows={rows} />
        </>
      )}
    </WidePanel>
  );
}
